import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import environment from "web/script/modules/environment";
import style from "./burger-menu-item.css";

function BurgerMenuItem(_ref) {
  var renderText = _ref.renderText,
      renderChevron = _ref.renderChevron,
      href = _ref.href,
      onClickEvent = _ref.onClickEvent;
  var iconName = environment.getFeature("rebrand_2020") ? "arrow-icon" : "chevron";
  return React.createElement("li", {
    className: style.menuItem
  }, React.createElement("a", {
    className: style.menuItemContent,
    href: href,
    onClick: onClickEvent
  }, renderText, renderChevron && React.createElement(SVGIcon, {
    className: style.menuItemChevron,
    name: iconName
  })));
}

export default BurgerMenuItem;
BurgerMenuItem.propTypes = {
  renderText: PropTypes.string.isRequired,
  renderChevron: PropTypes.bool,
  href: PropTypes.string,
  onClickEvent: PropTypes.func
};
BurgerMenuItem.defaultProps = {
  renderText: "",
  renderChevron: false,
  href: null
};